import React from 'react';
import { Tooltip as FlowBiteTooltip, TooltipProps as FlowBiteTooltipProps } from 'flowbite-react';
import { tooltipTheme } from '../../styles/themes/tooltip';
export type TooltipProps = Omit<FlowBiteTooltipProps, 'style'> & {
    ariaLabel?: string;
    testId?: string;
    children: React.ReactNode;
};

export const Tooltip: React.FC<TooltipProps> = (props) => {
    const { ariaLabel, testId, children, content, ...otherProps } = props;

    if (!content) {
        return <>{children}</>;
    }

    return (
        <div>
            <FlowBiteTooltip
                data-testid={testId}
                aria-label={ariaLabel}
                theme={tooltipTheme}
                style="auto"
                content={content}
                {...otherProps}
            >
                {children}
            </FlowBiteTooltip>
        </div>
    );
};
